module.exports = __webpack_public_path__ + "img/product-4.e54f9267.jpg";